<template>
  <div class="w-100 h-100 p-0 bg-white">
    <div class="row m-0">
      <div
        class="col menu-tab-border menu-tab-size"
        :class="{ 'menu-tab-border-select': isSelectCartTab() }"
        @click="clickTabCart"
      >
        <div
          class="menu-tab cursor-pointer d-flex color-fill"
          :class="{ 'select-color-fill': isSelectCartTab() }"
        >
          <div class="mx-2" style="margin-top: -2px">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M11 20C11 21.1 10.1 22 9 22C7.9 22 7 21.1 7 20C7 18.9 7.9 18 9 18C10.1 18 11 18.9 11 20ZM19 18C17.9 18 17 18.9 17 20C17 21.1 17.9 22 19 22C20.1 22 21 21.1 21 20C21 18.9 20.1 18 19 18ZM9.2 14.8V14.7L10.1 13H17.5C18.2 13 18.9 12.6 19.2 12L23.1 5L21.4 4L17.5 11H10.5L6.3 2H3V4H5L8.6 11.6L7.2 14C7.1 14.3 7 14.6 7 15C7 16.1 7.9 17 9 17H21V15H9.4C9.3 15 9.2 14.9 9.2 14.8ZM14 9.3L13.4 8.8C11.4 6.9 10 5.7 10 4.2C10 3 11 2 12.2 2C12.9 2 13.6 2.3 14 2.8C14.4 2.3 15.1 2 15.8 2C17 2 18 2.9 18 4.2C18 5.7 16.6 6.9 14.6 8.8L14 9.3Z"
              />
            </svg>
          </div>
          <div>カート</div>
        </div>
      </div>
      <div
        class="col menu-tab-border menu-tab-size"
        :class="{ 'menu-tab-border-select': isSelectOrderTab() }"
        @click="clickTabOrder"
      >
        <div
          class="menu-tab cursor-pointer d-flex color-stroke"
          :class="{ 'select-color-stroke': isSelectOrderTab() }"
        >
          <div class="mx-2" style="margin-top: -2px">
            <svg
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M19.6636 6.42413V21H6.33636V6.42413M3 7.56853L13 3L23 7.56853M13 11.7828C13 13.7124 13 15.7025 13 17.632M11.1818 8.63119L13 11.138L14.8182 8.63119M9.94546 11.7647H13.0045H16.0636M9.94546 15.1434C12.3348 15.1434 16.0636 15.1434 16.0636 15.1434"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <div>注文</div>
        </div>
      </div>
    </div>

    <!-- 境界線 -->
    <div class="line" />

    <div v-if="isSelectCartTab()" class="">
      <div class="scroll p-1 cart-area">
        <div v-if="!emptyCart" class="cart-bottom-area">
          <button class="outline-btn m-2" @click="clickCartReset">カートを空にする</button>
        </div>
        <CartItem
          v-for="(item, index) in this.getCartAcrylList()"
          v-bind:key="index + item.productId"
          v-bind:itemData="item"
        />
        <div
          v-if="this.getCartOptionList().length != 0"
          class="option-label text-start mt-2"
        >
          オプションアイテム
        </div>
        <CartItem
          v-for="(item, index) in this.getCartOptionList()"
          v-bind:key="index + item.productId"
          v-bind:itemData="item"
        />
        <div
          v-if="emptyCart"
          class="mt-5"
        >
          カートに商品が入っていません
        </div>
      </div>
      <hr v-if="!emptyCart" class="mt-0 mb-1">
      <div v-if="!emptyCart" class="cart-bottom-area">
        <button class="order-btn m-2" @click="clickTabOrder">注文する</button>
      </div>
    </div>

    <div v-if="isSelectOrderTab()" class="" style="">
      <div class="order-area order-scroll">
        <div
          v-if="emptyCart"
          class="mt-5"
        >
          カートに商品が入っていません
        </div>
        <template v-else>
          <div class="row px-2">
            <div class="col text-start">
              <p class="my-0 fw-bold mt-2">ご注文合計金額</p>
              <p class="text-end my-0 p-0 fw-bold" style="font-size: 20px">
                {{ this.totalPrice.toLocaleString() }}円
              </p>
              <hr class="mt-0" />
              <div class="d-flex flex-row gap-3">
                <div class="" style="flex: 1">
                  <p class="my-0 small">金額</p>
                  <p class="text-end my-0 p-0 fw-bold">
                    {{ this.price.toLocaleString() }}円
                  </p>
                  <hr class="mt-0" />
                </div>
                <div class="" style="flex: 1">
                  <p class="my-0 small">送料</p>
                  <p class="text-end my-0 p-0 fw-bold">
                    {{ this.delivPrice.toLocaleString() }}円
                  </p>
                  <hr class="mt-0" />
                </div>
              </div>
              <div class="d-flex flex-row gap-3">
                <div class="" style="flex: 1">
                  <p class="my-0 small">消費税</p>
                  <p class="text-end my-0 p-0 fw-bold">
                    {{ this.taxPrice.toLocaleString() }}円
                  </p>
                  <hr class="mt-0" />
                </div>
                <div class="" style="flex: 1">
                  <p class="my-0 small">割引金額</p>
                  <p class="text-end my-0 p-0 fw-bold status-error-color">
                    -{{ this.discount }}円
                  </p>
                  <hr class="mt-0" />
                </div>
              </div>
              <div class="d-flex flex-row gap-3">
                <div class="" style="flex: 1">
                  <p class="my-0 small">総数量</p>
                  <p class="text-end my-0 p-0 fw-bold">
                    {{ this.itemCount + this.optionCount }}
                  </p>
                  <hr class="mt-0" />
                </div>
                <div class="" style="flex: 1">
                  <p class="my-0 small">オプション数量</p>
                  <p class="text-end my-0 p-0 fw-bold">{{ this.optionCount }}</p>
                  <hr class="mt-0" />
                </div>
              </div>
            </div>
          </div>

          <div class="row m-0 mb-3">
            <div class="col text-start">
              <p class="my-0 fw-bold mt-2">配送先</p>
              <select
                class="form-select"
                name="destination_list"
                id="destination_list"
                v-model="selectedDestination"
              >
                <option disabled value="default">選択してください</option>
                <option
                  v-for="(d, index) in this.destinationList"
                  v-bind:key="index"
                  v-bind:value="index"
                >
                  <small>配送先{{ index }}: 〒{{ d.zip01 }}-{{ d.zip02 }}</small>
                </option>
              </select>
              <button
                @click="onClickEditDestination"
                class="outline-btn mt-3 mx-auto d-block"
              >
                配送先を編集・追加
              </button>
              <template v-if="this.destinationList[this.selectedDestination]">
                <p class="my-0 mt-2 small">会社名</p>
                <p class="text-end my-0 p-0 small">
                  {{ this.destinationList[this.selectedDestination].company_name }}
                </p>
                <hr class="my-0" />
                <p class="my-0 small">部署名</p>
                <p class="text-end my-0 p-0 small">
                  {{ this.destinationList[this.selectedDestination].department_name }}&nbsp;
                </p>
                <hr class="my-0" />
                <p class="my-0 small">氏名</p>
                <p class="text-end my-0 p-0 small">
                  {{ this.destinationList[this.selectedDestination].name01 }}
                  {{ this.destinationList[this.selectedDestination].name02 }}
                </p>
                <hr class="my-0" />
                <p class="my-0 small">電話番号</p>
                <p class="text-end my-0 p-0 small">
                  {{ this.destinationList[this.selectedDestination].tel01 }}-{{
                    this.destinationList[this.selectedDestination].tel02
                  }}-{{ this.destinationList[this.selectedDestination].tel03 }}
                </p>
                <hr class="my-0" />
                <p class="my-0 small">住所</p>
                <p class="text-end my-0 p-0 small">
                  〒{{ this.destinationList[this.selectedDestination].zip01 }}-{{
                    this.destinationList[this.selectedDestination].zip02
                  }}
                </p>
                <p class="text-end my-0 p-0 small">
                  {{ this.destinationList[this.selectedDestination].addr01 }}
                </p>
                <p class="text-end my-0 p-0 small">
                  {{ this.destinationList[this.selectedDestination].addr02 }}
                </p>
                <hr class="mt-0" />
              </template>
            </div>
          </div>
        </template>
      </div>

      <hr v-if="!emptyCart" class="mt-0 mb-1">

      <div v-if="!emptyCart" class="order-bottom-area">
        <div class="row m-0 mt-2" @click="onClickEstimates">
          <div class="col">
            <button class="outline-btn">見積書発行</button>
          </div>
        </div>
        <div class="row m-0 mt-2" @click="onClickOrder">
          <div class="col">
            <button class="order-btn">注文確定</button>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import CartItem from "@/components/acyrpro/CartItem_Ap.vue";
import { User } from "@/js/User.js";
import JSZip from "jszip";
import { ProductData } from "@/js/ProductData.js";
import { AcrylProductIds,PaymentType, GetAcryProductPrice } from "@/js/Const.js";
import { Common } from "@/js/common.js";
import { DiscountRatio, DelivPrice } from "@/js/CommonFunc.js";
import { FirebaseCommon } from "@/js/FirebaseCommon.js";
import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";
import { CenterViewState } from "@/js/Const.js";
import { Analytics } from "@/js/Analytics.js";

export default {
  name: "RightMenuCart_Ap",
  props: {},
  data: function () {
    return {
      isSelectTabCart: true, // 現在選択中のタブ
      destinationList: [],
      selectedDestination: "default", // 選択した配送先情報
      price: 0, // 金額
      delivPrice: 0, // 送料
      taxPrice: 0, // 消費税
      itemCount: 0, // 数量
      optionCount: 0, // オプション数量
      totalPrice: 0, // 合計金額
      discount: 0,
      isFirst:true,
    };
  },
  computed: {
    emptyCart(){
      return this.getCartAcrylList().length == 0 && this.getCartOptionList().length == 0;
    },
  },
  async mounted() {
    this.$nextTick(function() {
      if(this.isFirst) {
        this.isFirst = false
        Promise.all([this.initProcess()])
      }
    });
  },
  async created() {},
  components: {
    CartItem,
  },
  watch: {
    "$store.state.cartManager.cartList": function () {
      this.updatePayment();
    },
    "$store.state.isShowCart": function () {
      if( this.$store.state.isShowCart ){
        if(this.isSelectOrderTab()){
          this.clickTabOrder();
        }
      }
    },
  },
  methods: {
    async initProcess() {
      this.$store.commit("showLoading");
      await this.$store.state.saleProductManager.update().catch((e) => {
        this.$common.log(e);
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "エラーが発生しました \nリロードしてください");
      });

      await this.$store.state.optionManager.update().catch((e) => {
        this.$common.log(e);
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "エラーが発生しました \nリロードしてください");
      });

      await this.$store.state.cartManager.update().catch((e) => {
        this.$common.log(e);
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "エラーが発生しました \nリロードしてください");
      });

      // await this.$store.state.saleProductManager.update().catch((e) => {
      //   this.$common.log(e);
      //   this.$store.commit("showMessage", "エラーが発生しました");
      // });
      // await this.$store.state.optionManager.update().catch(() => {
      //   this.$store.commit("hideLoading");
      //   this.$store.commit("showMessage", "エラーが発生しました");
      // });
      // await this.$store.state.cartManager.update().catch(() => {});
      this.$store.commit("hideLoading");
    },
    propertyCheck(obj, pname) {
      if (obj == undefined || obj == null) {
        return "";
      }
      if (pname in obj) {
        return obj.pname;
      } else {
        return null;
      }
    },
    // ===== タブ周り ===== //
    clickTabCart() {
      this.isSelectTabCart = true;
    },
    async clickTabOrder() {
      this.isSelectTabCart = false;
      this.destinationList = [];
      this.$store.commit("showLoading");
      this.destinationList = [];
      this.destinationList = await User.getDestinationList().catch((e) => {
        this.$common.log(e);
        this.$store.commit("hideLoading");
        this.tabAction(1);
        this.$store.commit("showMessage", "エラーが発生しました");
      });

      await this.$store.state.cartManager.update().catch(() => {});
      this.updatePayment();
      this.$store.commit("hideLoading");
    },
    updatePayment() {
      let priceData = this.createProductPriceData();
      this.price = this.delivPrice = this.taxPrice = this.itemCount = this.optionCount = this.totalPrice = 0;
      this.price = priceData.productPrice;
      this.delivPrice = priceData.delivPrice;
      this.taxPrice = priceData.taxPrice;
      this.totalPrice = priceData.totalPrice;
      this.discount = priceData.discount;

      for (let item of this.$store.state.cartManager.getCartList()) {
        const isAcryl = AcrylProductIds.includes(item.productId);

        if (isAcryl) {
          // アクリル
          this.itemCount += parseInt(item.quantity);
        } else {
          // オプション
          this.optionCount += item.quantity;
        }
      }

      // this.price = this.delivPrice = this.taxPrice = this.itemCount = this.optionCount = this.totalPrice = 0;
      // this.delivPrice = 0;

      // for (let item of this.$store.state.cartManager.cartList) {
      //   const isAcryl = [ProductId.S, ProductId.M, ProductId.L].includes(item.productId);
      //   if (isAcryl) {
      //     // アクリル
      //     this.itemCount += parseInt(item.quantity);
      //     const priceData = GetAcryProductPrice(item.productId);
      //     this.price +=
      //     this.price += PriceAfterDiscount(priceData.priceBase, item.quantity);
      //     this.taxPrice += PriceAfterDiscount(
      //       priceData.price - priceData.priceBase,
      //       item.quantity
      //     );
      //   } else {
      //     // オプション
      //     this.optionCount += item.quantity;
      //     const priceData = this.$store.state.optionManager.getOptionDataForProductId(
      //       item.productId
      //     );
      //     this.price += priceData.priceBase * item.quantity;
      //     this.taxPrice += (priceData.price - priceData.priceBase) * item.quantity;
      //   }

      //   this.totalPrice = this.price + this.taxPrice + this.delivPrice;

      //   console.log(item);
      // }
    },
    isSelectCartTab() {
      return this.isSelectTabCart;
    },
    isSelectOrderTab() {
      return !this.isSelectTabCart;
    },

    // ===== タブ周り ===== //
    isProduct() {
      return this.$store.state.currentProduct;
    },

    onClickEditDestination() {
      this.$store.commit("switchShowCart");
      this.$store.commit("setShippingScreenType", "List");
      this.$store.commit("setCenterViewState", CenterViewState.Shipping);
    },

    async onClickEstimates() {
      if (this.selectedDestination == "default") {
        this.$store.commit("showMessage", "配送先を設定してください");
        return;
      }

      if( !this.checkAcrylProduct() ){
        this.$store.commit("showMessage", "オプションアイテムのみのご注文は出来ません");
        return;
      }

      this.$store.commit("showProgress", true);

      this.$store.commit("setProgressMessages", [
        "見積もりデータ保存中…",
        "しばらくお待ちください",
      ]);

      await this.$store.state.saleProductManager.update().catch((e) => {
        this.$common.log(e);
        this.$store.commit("hideLoading");
        this.$store.commit("showMessage", "エラーが発生しました");
      });

      let priceData = this.createProductPriceData();

      this.$store.commit("setEstimatesProductData", priceData.productList);

      this.$store.commit("hideProgress");

      // 配送先情報を設定
      let estimatesData = this.destinationList[this.selectedDestination];
      priceData.productList[0].totalPrice = priceData.totalPrice;
      priceData.productList[0].delivPrice = priceData.delivPrice;
      priceData.productList[0].productPrice = priceData.productPrice;
      priceData.productList[0].taxPrice = priceData.taxPrice;
      priceData.productList[0].discount = priceData.discount;
      estimatesData.issueDate = this.$common.getDateStringFromDate(new Date());

      this.$store.commit("showEstimates", estimatesData);
    },

    // カート内の商品価格の計算を行う
    createProductPriceData() {
      let productPriceData = {};
      productPriceData.productList = [];
      productPriceData.totalPrice = 0; // 払うべき金額 送料 + 商品合計 + 消費税合計 - 割引額
      productPriceData.delivPrice = 0; // 送料 (税別)
      productPriceData.productPrice = 0; // 商品合計 (税別)
      productPriceData.taxPrice = 0; // 消費税合計
      productPriceData.discount = 0; // アクリル商品の割引額 (税込)

      // アクリル
      for (let item of this.$store.state.cartManager.cartList) {
        const isAcryl = AcrylProductIds.includes(item.productId);
        const ProductPrice = GetAcryProductPrice(item.productId);

        if (isAcryl) {
          let product = {};
          let saleProduct = this.$store.state.saleProductManager.getProduct(
            item.productId
          );
          let p = new ProductData(
            saleProduct,
            saleProduct.productData["product_class_list2"][0]
          );
          product.title = p.getProductTitle();
          product.price = ProductPrice.priceBase;
          product.tax = ProductPrice.priceBase * Common.getTax();
          product.quantity = item.quantity;
          product.discount =
            ProductPrice.priceBase * product.quantity * (DiscountRatio(this.$store.state.cartManager.getCartProductQuantity(item.productId)) / 100);
          product.getProductTitle = function () {
            return "title";
          };
          productPriceData.productList.push(product);

          productPriceData.productPrice += product.price * product.quantity;
          // productPriceData.taxPrice += product.tax * product.quantity;
          productPriceData.discount += product.discount;
          // productPriceData.totalPrice += (product.price + product.tax) * product.quantity;
        }
      }

      // オプション品
      for (let item of this.$store.state.cartManager.cartList) {
        const isAcryl = AcrylProductIds.includes(item.productId);

        if (!isAcryl) {
          let product = {};
          const optionData = this.$store.state.optionManager.getOptionDataForProductId(
            item.productId
          );
          product.title = item.title;
          product.price = optionData.priceBase;
          product.quantity = item.quantity;
          product.tax = product.price * Common.getTax();
          product.getProductTitle = function () {
            return "title";
          };
          productPriceData.productList.push(product);
          productPriceData.productPrice += product.price * product.quantity;
          // productPriceData.taxPrice += product.tax * product.quantity;
          // productPriceData.totalPrice += (product.price + product.tax) * product.quantity;
        }
      }

      // 送料計算
      productPriceData.delivPrice = DelivPrice(productPriceData.productPrice);
      productPriceData.taxPrice += productPriceData.delivPrice * Common.getTax();
      productPriceData.totalPrice += productPriceData.delivPrice * (Common.getTax() + 1);

      // 消費税は割引を適応した後に適応
      productPriceData.taxPrice += (productPriceData.productPrice - productPriceData.discount) * (Common.getTax());
      productPriceData.totalPrice += (productPriceData.productPrice - productPriceData.discount) * (Common.getTax() + 1);

      // 最終金額
      productPriceData.taxPrice = Math.floor(productPriceData.taxPrice);
      productPriceData.totalPrice = Math.floor(productPriceData.totalPrice);

      return productPriceData;
    },

    async onClickOrder() {
      if (this.selectedDestination == "default") {
        this.$store.commit("showMessage", "配送先を設定してください");
        return;
      }

      if( !this.checkAcrylProduct() ){
        this.$store.commit("showMessage", "オプションアイテムのみのご注文は出来ません");
        return;
      }

      if (!this.$store.state.isSignature) {
        this.$store.commit("showResendContractDialog");
        //this.$store.commit("showMessage", "契約書へのサインが完了していません");
        return;
      }

      await this.orderProcess();
    },

    async orderProcess(bikou = "") {
      //this.$store.commit("showLoading");

      this.$store.commit("showProgress", true);
      this.$store.commit("setProgress", 0);
      this.$store.commit("setSendBytes", 0);

      this.$store.commit("setProgressMessages", [
        "デザイン送信中…",
        "しばらくお待ちください",
      ]);

      await this.$store.state.saleProductManager.update().catch((e) => {
        this.$common.log(e);
        //this.$store.commit("hideLoading");
        this.$store.commit("hideProgress");
        this.$store.commit("showMessage", "エラーが発生しました");
      });

      // 一応金額を再計算
      this.updatePayment();

      // await this.$store.state.optionManager.update().catch((e) => {
      //   this.$common.log(e);
      //   this.$store.commit("hideLoading");
      //   this.$store.commit("showMessage", "エラーが発生しました");
      // });

      let productData = []; // API送信時に使用
      let marginTotal = 0;
      let marginTotalIncTax = 0;
      //let priceTotal = 0;
      //let taxTotal = 0;

      let progressPlus = (95 / this.$store.state.products.length).toFixed();
      let prog = 0;
      //let totalSendBytes = 0;

      let acrylProducts = []; // firebaseへの登録で使用
      let optionProducts = []; // firebaseへの登録で使用
      let quantityTotal = 0; // 注文時間の推測に使用

      // 受注用のデータを並列処理
      acrylProducts = await this.createProductData();

      // プロダクト分ループ
      for (let p of acrylProducts) {
        let firstProg = prog;

        // 事前に生成していない場合のみ
        //console.log(p);
        if (!("acrylFile" in p)) {
          // デザインデータ、履歴データ、注文履歴情報の登録
          await p.registDatabase("", true, (progress, sendBytes) => {
            prog = firstProg + progressPlus * 0.8 * progress;
            if (sendBytes) {
              //totalSendBytes += sendBytes;
            }

            //this.$store.commit("setProgress", prog.toFixed());
            //this.$store.commit("setSendBytes", totalSendBytes);
          });
          console.log("end registDatabase");
        }

        for (let i = 0; i < p.quantity; ++i) {
          console.log("getProductData" + i);

          prog = firstProg + progressPlus * 0.8;
          //this.$store.commit("setProgress", prog.toFixed());
          let pdata = await p.getProductItemData(i);
          prog += progressPlus * 0.2;
          //this.$store.commit("setProgress", prog.toFixed());

          marginTotal += Number(pdata.margin);
          marginTotalIncTax += Number(pdata.margin_inctax);
          //priceTotal += Number(pdata.price_inctax);
          //priceTotal += Number(pdata.price_inctax);
          //taxTotal += pdata.tax;

          productData.push(pdata);
        }

        quantityTotal += parseInt(p.quantity);
      }

      // オプション品はここで追加
      for (let item of this.$store.state.cartManager.cartList) {
        const isAcryl = AcrylProductIds.includes(item.productId);

        if (!isAcryl) {
          let pdata = this.getOptionItemOrderData(item.productId, item.quantity);
          marginTotal += Number(pdata.margin);
          marginTotalIncTax += Number(pdata.margin_inctax);
          //priceTotal += Number(pdata.price_inctax);
          //taxTotal += pdata.tax;
          productData.push(pdata);

          // firebaseの注文履歴用のデータも作成しておく
          const optionData = this.$store.state.optionManager.getOptionDataForProductId(
            item.productId
          );

          optionProducts.push({
            productId: item.productId,
            price: Number(pdata.price_inctax) * item.quantity,
            quantity: item.quantity,
            designFilePath: optionData.imageUrl,
            cutlineFilePath: "",
            name: optionData.title,
          });
        }
      }

      quantityTotal += parseInt(this.$store.state.cartManager.cartList.length);

      this.$store.commit("setProgress", 3);

      console.log("updatePayment");
      this.updatePayment();
      let priceData = this.createProductPriceData();
      console.log(priceData);

      let delivTax = Math.ceil(priceData.delivPrice * this.$common.getTax());

      let data = {
        deliv_check: this.destinationList[this.selectedDestination].other_deliv_id,
        fee_base: "0",
        fee_tax_rate: "0",
        fee_tax: "0",
        fee: "0",
        // 送料(税抜き)
        deliv_fee_base: priceData.delivPrice,
        // 送料税率
        deliv_fee_tax_rate: (this.$common.getTax() * 100).toFixed(),
        // 送料税額
        deliv_fee_tax: delivTax,
        // 送料税込
        deliv_fee: priceData.delivPrice + delivTax,
        // マージン率
        margin_rate: User.userData.introduced_margin,
        // マージン額合計(税抜き)
        margin_total: marginTotal,
        // マージン額合計(税込み)
        margin_total_inctax: marginTotalIncTax,
        // 商品代金税込マージン込み
        subtotal:
          priceData.productPrice +
          Math.ceil(priceData.productPrice * this.$common.getTax()),
        // 合計税額 送料分の税額は省く
        tax: priceData.taxPrice - delivTax,
        payment_total: priceData.totalPrice,
        discount: priceData.discount,
        message: bikou ? bikou : "",
      };
      this.$common.log(data);

      this.$store.commit("setProgress", 3);

      const TotalTime = 0.34 * quantityTotal;
      let oneSecondProgress = (99 - 3) / TotalTime;
      let progress = 3.0;

      // console.log(quantityTotal);
      // console.log(TotalTime);
      // console.log(oneSecondProgress);

      let timer = setInterval(
        function () {
          progress += oneSecondProgress;

          if (99 < parseInt(progress)) {
            this.$store.commit("setProgress", 99);
          } else {
            this.$store.commit("setProgress", parseInt(progress));
          }
        }.bind(this),
        1000
      );

      // 注文APIを実行
      User.orderProduct(productData, data, PaymentType.CREDIT)
        .then((result) => {
          clearInterval(timer);

          // 注文履歴に登録
          // firestore
          this.$store.state.orderHistoryManager
            .registOrderHistoryData(acrylProducts, optionProducts, [], result.order_id)
            .then(() => {
              // 注文完了
              this.$store.commit("setProgress", 100);
              //this.$store.commit("hideLoading");
              this.$store.commit("hideProgress");
              result.payment_total = data.payment_total;
              this.$store.commit("showBankData", result);
              //this.$store.commit("resetCart");
              this.isCheckTerms = false;
              //this.resetCart();

              this.$store.commit("showCardPayment", {
                price: priceData.totalPrice,
                orderId: result.order_id,
              });

              // 決済完了後の処理を登録
              this.$store.commit("setCardPaymentCallback", ()=>{
                this.$store.commit("showMessage", "注文を受け付けました。");
                Analytics.purchase(result.order_id, data, productData);
              });
            })
            .catch(() => {
              this.$store.commit("hideProgress");
              this.$store.commit("showMessage", "エラーが発生しました");
            });
        })
        .catch((error) => {
          clearInterval(timer);
          this.$common.log(error);
          this.$store.commit("hideProgress");
          this.$store.commit("showMessage", "エラーが発生しました");
        });
    },
    downloadZip(url) {
      console.log("download zip :" + url);
      return new Promise((resolve) => {
        this.$blankAxios
          .get(url, {
            responseType: "arraybuffer",
            headers: { Accept: "application/zip" },
          })
          .then((response) => {
            const blob = new Blob([response.data], { type: "application/zip" });
            const file = new File([blob], "", {});
            JSZip.loadAsync(file).then((res) => {
              resolve(res);
            });
          })
          .catch(() => {
            resolve();
          });
      });
    },

    downloadPngImage(url) {
      console.log("download image :" + url);
      return new Promise((resolve) => {
        this.$blankAxios
          .get(url, { responseType: "arraybuffer", headers: { Accept: "image/png" } })
          .then((response) => {
            const blob = new Blob([response.data], { type: "image/png" });
            const file = new File([blob], "", {});
            resolve(file);
          })
          .catch(() => {
            resolve();
          });
      });
    },

    downloadSvgImage(url) {
      console.log("download image :" + url);
      return new Promise((resolve) => {
        this.$blankAxios
          .get(url, { responseType: "arraybuffer", headers: { Accept: "image/svg+xml" } })
          .then((response) => {
            const blob = new Blob([response.data], { type: "image/svg+xml" });
            const file = new File([blob], "", {});
            resolve(file);
          })
          .catch(() => {
            resolve();
          });
      });
    },

    clickCartReset(){
      this.$store.commit("setYesNoDialogCallback", this.cartReset);
      this.$store.commit("showYesNoDialog", `カートの中を空にします\n本当によろしいですか？`);
    },

    async cartReset(){
      await this.$store.state.cartManager.deleteAll().then(() => {
        this.$store.commit("showMessage", "カートを空にしました");
      });
    },

    getCartAcrylList() {
      return this.$store.state.cartManager.cartList.filter((item) =>
        AcrylProductIds.includes(item.productId)
      );
    },

    getCartOptionList() {
      return this.$store.state.cartManager.cartList.filter(
        (item) => !AcrylProductIds.includes(item.productId)
      );
    },

    getOptionItemOrderData(productId, quantity) {
      const optionData = this.$store.state.optionManager.getOptionDataForProductId(
        productId
      );
      console.log(optionData);

      let data = {
        product_id: productId,
        product_name: optionData.title,
        product_info: "front",
        front_image_path: "",
        front_image_path_mono: "",
        front_image_path_preview: "",
        front_image_path_outline: "",
        back_image_path: "",
        back_image_path_mono: "",
        back_image_path_preview: "",
        front_rib: "0",
        back_rib: "0",
        tag_type: "0",
        tag_image_path: "",
        tag_image_path_mono: "",
        product_price: optionData.priceBase,
        // 前面印刷価格
        paint_price_1: "0",
        // 後面印刷価格
        paint_price_2: "0",
        // タグ価格
        tag_price: "0",
        // 数量
        quantity: quantity,
        // マージン抜きの商品価格(税抜き)
        price_base: optionData.priceBase,
        // マージン額税抜き
        margin: "0",
        // マージン額税込
        margin_inctax: "0",
        // 税率(%)
        tax_rate: (Common.getTax() * 100).toFixed(),
        // 税額
        tax: Math.ceil(optionData.priceBase * Common.getTax()),
        // マージン込みの商品代金(税抜き)
        price: optionData.priceBase,
        // マージン込みの商品代金(税込)
        price_inctax: optionData.price,
        product_class_id: Number(optionData.productClassId),
        classcategory_id1: 0,
        classcategory_id2: 0,
      };
      console.log(data);
      return data;
    },

    // 並列処理で受注用のプロダクトデータを作成
    async createProductData() {
      const acrylProducts = [];
      for (let item of this.$store.state.cartManager.cartList) {
        const isAcryl = AcrylProductIds.includes(item.productId);

        if (isAcryl) {
          // アクリル
          // zipをダウンロードしてjsonを解析
          let url = await firebase
            .storage()
            .ref()
            .child(
              FirebaseCommon.getBaseFilePath() +
                FirebaseCommon.getZipFileName(item.tempId)
            )
            .getDownloadURL();
          console.log(url);
          let info = {};
          info.zipData = await this.downloadZip(url);
          let str = await info.zipData
            .file(item.tempId + "/product.json")
            .async("string");
          info.productJson = JSON.parse(str);

          // console.log(zipData);
          //console.log(info);

          let saleProduct = this.$store.state.saleProductManager.getProduct(
            item.productId
          );
          //console.log(saleProduct);

          let p = new ProductData(
            saleProduct,
            saleProduct.productData["product_class_list2"][0]
          );
          await p.createDataForJson(info, item.tempId);

          // 本来は毎回別IDをつけるが、カートデータをそのまま使用したいため
          // IDを引き継ぐ
          p.id = item.tempId;

          // acrylFileがあれば全部あるだろう
          if ("acrylFile" in item) {
            p.designFilePath = item.designFilePath;
            p.cutlineFilePath = item.cutlineFilePath;
            p.previewFilePath = item.previewFilePath;
            p.acrylFile = item.acrylFile;
          }

          acrylProducts.push(p);
        }
      }

      return acrylProducts;
    },

    // カート内にアクリル商品があるかチェック
    checkAcrylProduct(){
      for (let item of this.$store.state.cartManager.cartList) {
        const isAcryl = AcrylProductIds.includes(item.productId);
          if (isAcryl) {
            return true;
          }
        }
        return false;
    },

  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
$cart-tab-size:39px;
$cart-line-size:2px;
$cart-buttom-size:65px;
$order-buttom-size:110px;


/* タブ関連 */

.line {
  height: $cart-line-size;
  background-color: #e6e5eb;
}

.cart-area{
  height: calc( 100vh - #{$header-height} - #{$cart-tab-size} - #{$cart-line-size} - #{$cart-buttom-size} - 9px );
}

.order-area{
  height: calc( 100vh - #{$header-height} - #{$cart-tab-size} - #{$cart-line-size} - #{$order-buttom-size} - 9px );
}

.order-scroll{
  overflow-x: hidden;
  overflow-y: scroll;
}

.cart-bottom-area{
  height: $cart-buttom-size;
}

.order-bottom-area{
  height: $order-buttom-size;
}

.item-scroll {
  /* background-color: rgb(132, 135, 133); */
  display: flex;
  flex-direction: column;
  height: 500px;
  overflow-y: scroll;
}

.list-scroll {
  /* background-color: rgb(132, 135, 133); */
  display: flex;
  flex-direction: column;
  height: 500px;
  overflow-y: scroll;
}

.scroll {
  background-color: transparent;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  overflow-x: hidden;
  align-items: left;
  flex: 1;
  padding-right: 10px;
  padding-left: 10px;
}

.select-box {
  width: 100%;
  padding: 10px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border: 1px solid #999;
  background: #eee;
  /* background: url(arrow01.png) right 50% no-repeat, -webkit-linear-gradient(top, #fff 0%,#efebe1 100%);
	background: url(arrow01.png) right 50% no-repeat, linear-gradient(to bottom, #fff 0%,#efebe1 100%); */
  background-size: 20px, 100%;
}

.acry-btn {
  margin: 10px;
  /* padding: 3px 30px; */
  color: #000000;
  border-color: #000000;
  background-color: #ffff00;
  border-radius: 15px;
  font-size: 15px;
  border: 1px;
}

.number-field {
  margin-right: 10px;
  padding: 0.25rem;
  width: 70px;
  border: solid 0px #ffffff;
  border-radius: 4px;
  background-color: #e6e5eb;
}
.order-btn {
  width: 250px;
  height: 40px;
  border: none;
  color: white;
  border-radius: 20px;
  margin-top: 1px;
  background-color: #4cae51;
  font-weight: bold;
}
.outline-btn {
  width: 250px;
  height: 40px;
  border: 3px solid $primary-main-color;
  color: $primary-main-color;
  border-radius: 20px;
  margin-top: 1px;
  background-color: white;
  font-weight: bold;
}
.option-label {
  color: $text-sub-color;
  font-weight: bold;
}
.menu-tab-size{
  height: $cart-tab-size;
}
.menu-tab-border {
  width: 100%;
  border: 3px solid $border-sub-color;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
}
.menu-tab-border-select {
  width: 100%;
  border: 3px solid $primary-main-color;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
}
.menu-tab {
  font-size: 1em;
  margin: 12px;
  margin-top: 7px;
  margin-bottom: 5px;
  font-weight: bold;
  color: $text-sub-color;
}
.color-fill {
  fill: $text-sub-color;
}
.color-stroke {
  stroke: $text-sub-color;
}
.select-color-fill {
  color: $primary-main-color;
  fill: $primary-main-color;
}
.select-color-stroke {
  color: $primary-main-color;
  stroke: $primary-main-color;
}
</style>
